export default "__VITE_ASSET__CSZ3f128__"